var map = {
	"./gai01.mp3": "1af4",
	"./gai02.mp3": "1fb9",
	"./gai03.mp3": "7b05",
	"./gai04.mp3": "fd3c",
	"./gai05.mp3": "ddf8",
	"./gai06.mp3": "777d",
	"./gai07.mp3": "2aad",
	"./gai08.mp3": "4376",
	"./gai09.mp3": "52fc",
	"./gai10.mp3": "b2dc",
	"./gai11.mp3": "35ff",
	"./gai12-2.mp3": "389c",
	"./gai12.mp3": "862d",
	"./gai13.mp3": "50f2",
	"./gai14.mp3": "ba3e",
	"./gai15.mp3": "aa83",
	"./gai16.mp3": "2d85",
	"./gai17.mp3": "5a0b",
	"./gai18.mp3": "e579",
	"./gai19.mp3": "bc93",
	"./gai20.mp3": "faee",
	"./gai21.mp3": "8818"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33cb";